var eventSearchHeaderBlock = {
    $eventSearchHeaderBlock: $('.event-search-header-block'),
    $body: $('body'),

    init: function() {
        var _this = this;

        if (!_this.$eventSearchHeaderBlock.length) {
            return;
        }

        _this.eventSearchTemplate = Handlebars.compile($('#event-search-template').html());
        _this.$input = _this.$eventSearchHeaderBlock.find('input');
        _this.$output = _this.$eventSearchHeaderBlock.find('.output');

        _this.initSearch(window.festivalData);
        _this.listener();
    },

    initSearch: function(eventData) {
        var _this = this;

        _this.searchEngine = new JsSearch.Search('id');
        _this.searchEngine.addDocuments(eventData);
        _this.searchEngine.addIndex('city');
        _this.searchEngine.addIndex('name');
        _this.searchEngine.addIndex('location');
    },

    listener: function() {
        var _this = this;

        _this.$input.on('click keyup paste', _this.change.bind(this));
    },

    clickAwayListener: function() {
        var _this = this,
            eventName = 'click.eventSearchHeaderBlock';

        _this.$body.off(eventName);
        _this.$body.on(eventName, function(e) {
            if (!$(e.target).closest('.search-container').length) {
                _this.setOutput([]);
                _this.$body.off(eventName);
            }
        });
    },

    change: function() {
        var _this = this,
            val = _this.$input.val();

        _this.clickAwayListener();

        if (val.length < 2) {
            _this.setOutput([]);
            return;
        }

        _this.setOutput(_this.searchEngine.search(val));
    },

    /**
     *
     * @param {Array} eventData
     */

    setOutput: function(eventData) {
        var _this = this;

        _this.$input.toggleClass('has-results', eventData.length > 0);

        _this.$output.html(_this.eventSearchTemplate(eventData));
    }
};
